import { useNavigate } from "react-router-dom";

export function Header() {
    const navigate = useNavigate();
    return (
        <header className="flex w-full shrink-0 items-center justify-between px-4 py-3 md:px-8 md:py-4" onClick={() => navigate("/")}>
            <div className="flex items-center gap-2.5">
                <div
                    className="size-8 shrink-0 rounded-full md:size-9"
                    style={{
                        background:
                            "conic-gradient(from 180deg, #e85c33, #f5a8c8, #fbbf8a, #e85c33)",
                    }}
                    aria-hidden
                />
                <span className="text-lg font-bold tracking-tight text-foreground md:text-xl">
                    SFisFun
                </span>
            </div>
            <div className="flex items-center gap-3 md:gap-6">
                <a
                    href="#about"
                    className="hidden text-sm font-medium text-foreground hover:text-muted sm:inline"
                >
                    About
                </a>
                <button
                    type="button"
                    className="hidden rounded-full bg-accent-orange px-5 py-2.5 text-sm font-semibold text-white transition hover:opacity-90 md:inline-flex"
                >
                    + Submit an event
                </button>
                <button
                    type="button"
                    aria-label="Submit an event"
                    className="flex size-9 items-center justify-center rounded-full bg-accent-orange text-lg font-bold text-white md:hidden"
                >
                    +
                </button>
            </div>
        </header>
    );
}
